import { Box, Container, Skeleton, SkeletonText, VStack, HStack, useColorModeValue } from '@chakra-ui/react'

export function BlogPostSkeleton() {
  const bgColor = useColorModeValue('gray.900', 'gray.900')
  const skeletonStartColor = useColorModeValue('gray.700', 'gray.700')
  const skeletonEndColor = useColorModeValue('gray.800', 'gray.800')

  return (
    <Box bg={bgColor} minHeight="100vh" py={8}>
      <Container maxW="4xl">
        <VStack spacing={8} align="stretch">
          <Skeleton height="40px" width="150px" startColor={skeletonStartColor} endColor={skeletonEndColor} />

          <Skeleton height="400px" startColor={skeletonStartColor} endColor={skeletonEndColor} />

          <VStack spacing={4} align="stretch">
            <HStack>
              <Skeleton height="24px" width="80px" startColor={skeletonStartColor} endColor={skeletonEndColor} />
              <Skeleton height="24px" width="80px" startColor={skeletonStartColor} endColor={skeletonEndColor} />
            </HStack>

            <Skeleton height="40px" startColor={skeletonStartColor} endColor={skeletonEndColor} />

            <HStack>
              <Skeleton height="20px" width="150px" startColor={skeletonStartColor} endColor={skeletonEndColor} />
              <Skeleton height="20px" width="100px" startColor={skeletonStartColor} endColor={skeletonEndColor} />
            </HStack>
          </VStack>

          <SkeletonText
            noOfLines={10}
            spacing="4"
            skeletonHeight="4"
            startColor={skeletonStartColor}
            endColor={skeletonEndColor}
          />
        </VStack>
      </Container>
    </Box>
  )
}
